<template>
    <div>
        <card-header icon="fa-comment-lines">
            <template #title>
                <span v-if="data.enrollment">Reflections — {{data.enrollment.course_name}}</span>
                <span v-else>Reflections</span>
            </template>
        </card-header>

        <card-body v-if="data.enrollment">

            <!-- Identity / context -->
            <card-list>
                <subheader-list-item title="Enrollment" icon="fa-user"/>
                <container-list-item no-border>
                    <data-row title="Student" v-if="data.user">
                        {{data.user.first_name}} {{data.user.last_name}}
                    </data-row>
                    <data-row title="Email" v-if="data.user">
                        <a :href="`mailto:${data.user.email}`">{{data.user.email}}</a>
                    </data-row>
                    <data-row title="Course">{{data.enrollment.course_name}}</data-row>
                    <data-row title="Custom Name" v-if="data.enrollment.customName">{{data.enrollment.customName}}</data-row>
                    <data-row title="STEM" v-if="data.enrollment.stem == 1">
                        <b-tag type="is-danger">STEM Course</b-tag>
                    </data-row>
                </container-list-item>
            </card-list>

            <separator-list-item/>

            <!-- Reflections -->
            <card-list>
                <subheader-list-item
                    title="Milestone Reflections"
                    icon="fa-flag-swallowtail"
                    :badge="(data.reflections || []).length"/>

                <container-list-item v-for="r in data.reflections" :key="r.id" no-border>
                    <div class="t-data-row no-border">
                        <div class="t-data-title">
                            <strong>{{r.hour_threshold}} Hour</strong>
                        </div>
                        <div class="t-data-value">
                            <div class="reflection-body">{{r.content}}</div>
                        </div>
                    </div>
                </container-list-item>

                <container-list-item v-if="!data.reflections || !data.reflections.length" padded>
                    <span class="has-text-grey is-size-7">No reflections submitted.</span>
                </container-list-item>
            </card-list>

        </card-body>

        <card-body v-else-if="loading">
            <card-list>
                <container-list-item padded>
                    <span class="has-text-grey is-size-7">Loading...</span>
                </container-list-item>
            </card-list>
        </card-body>

        <card-body v-else>
            <card-list>
                <container-list-item padded>
                    <span class="has-text-grey is-size-7">Enrollment not found.</span>
                </container-list-item>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import DataRow from "@/TIER/components/DataRow";
    import {client as http} from '@/http_client';

    export default {
        components: {
            CardHeader, CardBody,
            CardList, SubheaderListItem, SeparatorListItem, ContainerListItem,
            DataRow
        },
        props: ['card', 'props'],
        data() {
            return {
                data: {},
                loading: true
            };
        },
        mounted() {
            this.load();
        },
        methods: {
            load() {
                this.loading = true;
                http.get(`faxes/enrollments/${this.props.enrollId}/reflections`, {force: true}).then(response => {
                    this.data = response.data || {};
                }).catch(err => {
                    console.log(err);
                    this.data = {};
                }).finally(() => {
                    this.loading = false;
                    this.$emit('loading', false);
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .reflection-body {
        white-space: pre-wrap;
        line-height: 1.5;
        color: #333;
        font-size: 0.85rem;
    }
    .t-data-row {
        font-size: 0.85rem;
        display: flex;
        flex-wrap: wrap;
        &.no-border {
            border-bottom: 0;
        }
        .t-data-title {
            color: #336699;
            border-right: 1px solid #efefef;
            flex: 0 0 25%;
            min-width: 25%;
            padding: 0.4rem 0.3rem 0.3rem 1.3rem;
        }
        .t-data-value {
            flex-basis: 0;
            flex-grow: 1;
            max-width: 100%;
            padding: 0.4rem 0.3rem 0.3rem 0.8rem;
        }
    }
</style>
